angular.module('commerce', [
    'portal.i18n',
    'portal.countries',
    'studies',
    'ui.router',
    'user',
]);
